import { Link } from "react-router-dom";
import { Linkedin, Twitter, Youtube, Instagram } from "lucide-react";

const FOOTER_LINKS = {
  attend: [
    { label: "Why Attend", href: "/attend" },
    { label: "Ticket Types", href: "/attend#tickets" },
    { label: "Join Priority List", href: "#priority" },
    { label: "FAQ", href: "/faq" },
  ],
  program: [
    { label: "Program Overview", href: "/program" },
    { label: "Audience Pathways", href: "/program#pathways" },
    { label: "Workshops & Labs", href: "/program#workshops" },
    { label: "Agenda", href: "/program#agenda" },
  ],
  speakers: [
    { label: "Speaker Directory", href: "/speakers" },
    { label: "Apply to Speak", href: "/speakers#apply" },
    { label: "Speaker FAQ", href: "/faq#speakers" },
  ],
  connect: [
    { label: "Networking", href: "/connect" },
    { label: "AI Concierge", href: "/connect#concierge" },
    { label: "Expo Floor", href: "/expo" },
    { label: "Startup Zone", href: "/expo#startups" },
  ],
  partner: [
    { label: "Sponsor Opportunities", href: "/partner" },
    { label: "Exhibitor Packages", href: "/partner#exhibitors" },
    { label: "Request Prospectus", href: "/partner#prospectus" },
    { label: "Partner FAQ", href: "/faq#sponsors" },
  ],
  plan: [
    { label: "Niagara Falls", href: "/plan" },
    { label: "Travel & Hotel", href: "/plan#travel" },
    { label: "Venue (TBA)", href: "/plan#venue" },
    { label: "Accessibility", href: "/plan#accessibility" },
  ],
};

export default function Footer() {
  return (
    <footer style={{ backgroundColor: "var(--surface)", borderTop: "1px solid var(--border)" }} data-testid="footer">
      <div className="container-xl py-16">
        {/* Top row */}
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-12 pb-12 border-b" style={{ borderColor: "var(--border)" }}>
          {/* Brand */}
          <div className="lg:col-span-2">
      <Link to="/" className="flex items-center mb-5" data-testid="footer-logo">
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_6bb71053-4e67-4930-bf10-a7af9cda97ea/artifacts/5ia3fp43_core-ai-summit-logo-on-black.png"
              alt="Core AI Summit + Tradeshow"
              style={{ height: "44px", width: "auto" }}
            />
          </Link>
            <p className="text-sm leading-relaxed mb-6 max-w-xs" style={{ color: "var(--text-muted)" }}>
              Canada's AI conference built for practical implementation, measurable outcomes, and meaningful connections.
            </p>
            <div className="text-xs uppercase tracking-widest mb-2" style={{ color: "var(--cyan)", fontFamily: "var(--font-mono)" }}>
              June 2027
            </div>
            <div className="text-sm" style={{ color: "var(--text-muted)" }}>
              Niagara Falls, Ontario<br />
              <span className="text-xs" style={{ color: "var(--text-muted)", opacity: 0.6 }}>Exact dates & venue to be announced</span>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: Linkedin, href: "#", label: "LinkedIn" },
                { icon: Twitter, href: "#", label: "Twitter" },
                { icon: Youtube, href: "#", label: "YouTube" },
                { icon: Instagram, href: "#", label: "Instagram" },
              ].map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-9 h-9 flex items-center justify-center rounded-lg border transition-all"
                  style={{ borderColor: "var(--border)", color: "var(--text-muted)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = "var(--cyan)"; e.currentTarget.style.color = "var(--cyan)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.color = "var(--text-muted)"; }}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-4 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {[
              { title: "Attend", links: FOOTER_LINKS.attend },
              { title: "Program", links: FOOTER_LINKS.program },
              { title: "Speakers", links: FOOTER_LINKS.speakers },
              { title: "Connect", links: FOOTER_LINKS.connect },
              { title: "Partner", links: FOOTER_LINKS.partner },
              { title: "Plan", links: FOOTER_LINKS.plan },
            ].map(({ title, links }) => (
              <div key={title}>
                <div className="text-xs uppercase tracking-widest font-semibold mb-4" style={{ color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>
                  {title}
                </div>
                <ul className="space-y-2">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm transition-colors hover:text-white"
                        style={{ color: "var(--text-muted)" }}
                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom row */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs" style={{ color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>
            &copy; 2025 Core AI Summit. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            {["Privacy Policy", "Terms of Use", "Accessibility"].map((item) => (
              <a
                key={item}
                href="#"
                className="text-xs transition-colors hover:text-white"
                style={{ color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
